export default __webpack_public_path__ + "static/media/icon-node-tipo-mapa.eb601716.svg";